<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px">
          <v-col cols="12">
            <!-- <h1>{{ isEditing ? 'Editar' : 'Crear' }} {{ isEditing ? beneficio.tipo : 'Asistencia o Beneficio' }}</h1> -->
            <h1>{{ isEditing ? "Editar" : "Crear" }} Alianza InterMx</h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-container>
      <v-skeleton-loader v-if="loading" class="pa-5">
        <template #default>
          <v-row>
            <v-col v-for="i in 8" :key="i" cols="12" md="6">
              <v-skeleton-loader type="card" height="56" class="rounded my-3" />
            </v-col>
          </v-row>
        </template>
      </v-skeleton-loader>
      <v-form v-else ref="form" v-model="valid" lazy-validation>
        <div class="container-pefai-cards">
          <v-row class="padding-pefai">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="alianza.nombre_alianza"
                label="Nombre Alianza *"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.status"
                label="Status *"
                :disabled="!isEditing"
                :items="statusAlianzas"
                item-text="value"
                item-value="id"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="alianza.fecha_inicio"
                label="Fecha de Inicio *"
                placeholder="dd/mm/aaaa"
                outlined
                primary
                color="#00a7e4"
                type="date"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.responsable_id"
                label="Responsable *"
                :items="responsables"
                item-text="nombreCompleto"
                item-value="id"
                outlined
                primary
                :rules="[rules.required]"
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" v-if="alianza.status === 3">
              <v-text-field
                v-model="alianza.fecha_baja"
                label="Fecha de Baja"
                placeholder="dd/mm/aaaa"
                :rules="[rules.requiredByInactiveStatus]"
                outlined
                primary
                color="#00a7e4"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="alianza.status === 3">
              <v-text-field
                v-model="alianza.motivo_baja"
                label="Motivo de Baja"
                :rules="[rules.requiredByInactiveStatus]"
                placeholder="Ingrese el motivo de baja"
                outlined
                primary
                color="#00a7e4"
                type="text"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.agente_id"
                label="Agente *"
                placeholder="Ingrese el ID del agente"
                :rules="[rules.numberOrEmpty, rules.required]"
                outlined
                primary
                color="#00a7e4"
                item-text="nombreCompleto"
                item-value="id"
                :items="agentes"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="alianza.envios_onboarding"
                label="Envios Onboarding"
                placeholder="Ingrese el número de envíos"
                :rules="[rules.numberOrEmpty]"
                outlined
                primary
                color="#00a7e4"
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                readonly
                disabled
                v-model="alianza.canal"
                label="Canal *"
                :items="canales"
                :rules="[rules.required, isAlianzasOnly]"
                item-text="canal"
                item-value="id"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.ramos"
                label="Ramo *"
                multiple
                :items="ramos"
                item-text="ramo"
                item-value="id"
                outlined
                primary
                :rules="[rules.required]"
                color="#00a7e4"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.etiqueta }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ alianza.ramos.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- NUEVOS CAMPOS -->
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.validacion_telefono"
                label="Validación de Teléfono*"
                item-text="text"
                item-value="value"
                :items="siNoOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.generar_certificado"
                label="Generar Certificado*"
                item-text="text"
                item-value="value"
                :items="siNoOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="alianza.url_certificado_aseguradora"
                label="URL Certificado Aseguradora"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="alianza.periodos_fijos"
                label="Periodos Fijos*"
                item-text="text"
                item-value="value"
                :items="siNoOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="alianza.periodo_gracia_pago"
                label="Periodo de Gracia de Pago*"
                type="number"
                min="0"
                :rules="[rules.required, rules.numberNonNegative]"
                outlined
                color="#00a7e4"
                hint="Ingrese el número de días"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="alianza.periodo_gracia_redencion"
                label="Periodo de Gracia de Redención*"
                type="number"
                min="0"
                :rules="[rules.required, rules.numberNonNegative]"
                outlined
                color="#00a7e4"
                hint="Ingrese el número de días"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center">
              <v-checkbox
                v-model="alianza.redencion_sin_emision"
                color="#00a7e4"
                hide-details
              >
                <template v-slot:label>
                  <span>Habilitar redención sin emisión</span>
                  <v-tooltip bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        class="ml-2"
                        color="#00a7e4"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      Permite habilitar un flujo extra de solicitudes de redención para clientes de esta alianza
                      que aún no tienen emisión en el sistema. La búsqueda se hace por número
                      de certificado y la periodicidad se valida por certificado y alianza.
                    </span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </div>

        <v-row class="mt-5">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              rounded
              dark
              outlined
              color="#00a7e4"
              class="mr-4"
              @click="$router.push('/administracion/alianzas-intermx')"
            >
              Cancelar
            </v-btn>
            <v-btn
              rounded
              dark
              class="common-botton"
              :loading="loading"
              @click="abrirConfirmacion"
            >
              {{ isEditing ? "Actualizar" : "Crear" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <CommonConfirmationModal :dialog="dialogConfirmacion" @userChoice="onConfirmacion" />
    </v-container>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import CommonConfirmationModal from "@/components/commonComponents/CommonConfirmationModal.vue";
import {
  getResponsablesAlianzas,
  getAgentesByRolYCanal,
} from "@/services/user/user.service";
import {
  getAlianzaById,
  saveAlianza,
  updateAlianza,
} from "@/services/alianzas/alianzas.service";
import { getCanalList } from "@/services/canal/canal.service.js";
import { getRamoList } from "@/services/ramo/ramo.service.js";

export default {
  components: {
    CommonCard, CommonConfirmationModal
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      loading: true,
      alianza: {
        nombre_alianza: "",
        status: "",
        ramos: [],
        canal: "",
        fecha_inicio: today,
        responsable_id: "",
        fecha_baja: "",
        motivo_baja: "",
        agente_id: "",
        envios_onboarding: "",
        // NUEVOS CAMPOS
        validacion_telefono: null,
        generar_certificado: null,
        url_certificado_aseguradora: "",
        periodos_fijos: null,
        periodo_gracia_pago: null,
        periodo_gracia_redencion: null,
        redencion_sin_emision: false,
      },
      valid: false,
      dialogConfirmacion: false,
      responsables: [],
      agentes: [],
      ramos: [],
      canales: [],
      statusAlianzas: [
        { id: 1, value: "Activo" },
        { id: 2, value: "Inactivo" },
        { id: 3, value: "Baja" },
      ],
      siNoOptions: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      rules: {
        required: (value) =>
          value !== null && value !== undefined && value !== ""
            ? true
            : "Este campo es requerido",
        number: (value) =>
          (!isNaN(value) && value >= 0) ||
          "Debe ser un número válido mayor o igual a 0",
        numberNonNegative: (value) =>
          (!isNaN(value) && value >= 0) ||
          "Debe ser un número mayor o igual a 0",
        integer: (value) =>
          (Number.isInteger(Number(value)) && Number(value) > 0) ||
          "Debe ser un número entero mayor a 0",
        numberOrEmpty: (value) => {
          if (value === null || value === undefined || value === "") {
            return true;
          }
          const num = Number(value);
          return (
            (!isNaN(num) && num > 0) ||
            "Debe ser un número mayor a 0 o dejarse vacío"
          );
        },
        requiredByInactiveStatus: (value) => {
          if (this.alianza.status === 2) {
            return value !== null && value !== undefined && value !== ""
              ? true
              : "Este campo es requerido cuando el estatus es Inactivo";
          }
          return true;
        },
      },
    };
  },
  async mounted() {
    this.loading = true;
    this.getRamos();
    await this.getCanales();
    this.getResponsablesAlianza();
    this.getAllAgentesByRolYCanal();
    if (this.isEditing) {
      this.getAlianza();
      this.alianza.canal =
        this.canales.find((c) => c.canal === "ALIANZAS INTER.MX")?.id || "";
    } else {
      this.alianza.status = 1;
    }
    this.loading = false;
  },
  async created() {
    await this.getCanales();
    const canalAlianzas = this.canales.find(
      (c) => c.canal === "ALIANZAS INTER.MX",
    );
    if (!canalAlianzas) {
      this.$toast.error(
        "No se ha podido encontrar el canal de ALIANZAS INTER.MX",
        {
          position: "top-right",
          timeout: 2000,
        },
      );
      setTimeout(() => {
        this.$router.push("/administracion/alianzas-intermx");
      }, 2000);
    }
    this.alianza.canal = canalAlianzas.id;
  },
  computed: {
    isEditing() {
      return this.$route.params.id ? true : false;
    },
  },
  methods: {
    guardarAlianza() {
      const payload = {
        id: this.alianza.id,
        nombre_alianza: this.alianza.nombre_alianza,
        status: this.alianza.status,
        canal: this.alianza.canal,
        ramos: this.alianza.ramos,
        fecha_inicio: this.alianza.fecha_inicio,
        responsable_id: this.alianza.responsable_id,
        fecha_baja:
          this.isEditing && this.alianza.status === 3
            ? this.alianza.fecha_baja
            : "",
        motivo_baja:
          this.isEditing && this.alianza.status === 3
            ? this.alianza.motivo_baja
            : "",
        agente_id: this.alianza.agente_id,
        envios_onboarding: this.alianza.envios_onboarding,
        // NUEVOS CAMPOS
        validacion_telefono: this.alianza.validacion_telefono,
        generar_certificado: this.alianza.generar_certificado,
        url_certificado_aseguradora: this.alianza.url_certificado_aseguradora,
        periodos_fijos: this.alianza.periodos_fijos,
        periodo_gracia_pago: this.alianza.periodo_gracia_pago,
        periodo_gracia_redencion: this.alianza.periodo_gracia_redencion,
        redencion_sin_emision: this.alianza.redencion_sin_emision,
      };
      const alianzaAction = this.isEditing
        ? updateAlianza(this.$route.params.id, payload)
        : saveAlianza(payload);
      alianzaAction
        .then(() => {
          this.$toast.success(
            this.isEditing
              ? "Alianza actualizada con éxito"
              : "Alianza creada con éxito",
            {
              position: "top-right",
              timeout: 2000,
            },
          );
          setTimeout(() => {
            this.$router.push("/administracion/alianzas-intermx");
          }, 2000);
        })
        .catch((error) => {
          this.$toast.error(
            (this.isEditing ? "Error al actualizar la alianza: " : "Error al crear la alianza: ") + error.message,
            {
              position: "top-right",
              timeout: 3000,
            },
          );
        });
    },
    cleanDate(fechaString) {
      const date = new Date(fechaString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    async getResponsablesAlianza() {
      const response = await getResponsablesAlianzas();
      this.responsables = response.agentes;
    },
    async getAllAgentesByRolYCanal() {
      const payload = {
        rol: "AGENT",
        canalId:
          this.canales.find((c) => c.canal === "ALIANZAS INTER.MX")?.id || "",
      };
      const response = await getAgentesByRolYCanal(payload);
      this.agentes = response.data.agentes;
    },
    getAlianza() {
      getAlianzaById(this.$route.params.id)
        .then((response) => {
          const alianzaData = response.alianza;
          this.alianza = {
            nombre_alianza: alianzaData.nombre,
            status: alianzaData.status,
            canal:
              this.canales.find((c) => c.canal === "ALIANZAS INTER.MX")?.id ||
              null,
            ramos: alianzaData.ramosList.map((r) => r.id),
            fecha_inicio: alianzaData.fecha_inicio
              ? this.cleanDate(alianzaData.fecha_inicio)
              : null,
            responsable_id: alianzaData.responsableId,
            fecha_baja: alianzaData.fecha_baja
              ? this.cleanDate(alianzaData.fecha_baja)
              : null,
            motivo_baja: alianzaData.motivoBaja,
            agente_id: alianzaData.agenteId,
            envios_onboarding: alianzaData.enviosOnboarding,
            // NUEVOS CAMPOS
            validacion_telefono:
              alianzaData.validacionTelefono === true ? 1 : 0,
            generar_certificado:
              alianzaData.generarCertificado === true ? 1 : 0,
            url_certificado_aseguradora:
              alianzaData.urlCertificadoAseguradora || "",
            periodos_fijos: alianzaData.periodosFijos === true ? 1 : 0,
            periodo_gracia_pago: alianzaData.periodoGraciaPago || 0,
            periodo_gracia_redencion: alianzaData.periodoGraciaRedencion || 0,
            redencion_sin_emision: alianzaData.redencionSinEmision === true,
          };
        })
        .catch((error) => {
          this.$toast.error(
            "Error al cargar la alianza, verifica el id ingresado o reporta al equipo de soporte en caso de problemas " +
              error.message,
            {
              position: "top-right",
              timeout: 4000,
            },
          );
          setTimeout(() => {
            this.$router.push("/administracion/alianzas-intermx");
          }, 4000);
        });
    },
    async getRamos() {
      this.ramos = await getRamoList();
    },
    async getCanales() {
      this.canales = await getCanalList();
    },
    isAlianzasOnly(value) {
      if (!Array.isArray(this.canales))
        return "La lista de canales no está disponible.";
      const canalAlianzas = this.canales.find(
        (c) => c.canal === "ALIANZAS INTER.MX",
      );
      if (!canalAlianzas)
        return "No se encontró el canal ALIANZAS INTER.MX en la lista.";
      if (value === canalAlianzas.id) return true;
      return "El canal debe ser ALIANZAS INTER.MX.";
    },
    abrirConfirmacion() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("Formulario no valido", {
          position: "top-right",
          timeout: 4000,
        });
        return;
      }
      this.dialogConfirmacion = true;
    },
    onConfirmacion(confirmado) {
      this.dialogConfirmacion = false;
      if (confirmado) this.guardarAlianza();
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.common-botton {
  background-color: #00a7e4 !important;
}
</style>
